// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__2BW99","MenuItem_active":"MenuItem_MenuItem_active__ykrFr","MenuItem_clickable":"MenuItem_MenuItem_clickable__2-ULp"};